import React from "react";
import "./media.styles.css";

export const Media = () => {
  return <div className="under">Under Development</div>;
};
